<template>
	<div id="wallet-screen">
		<hero-jumbotron
			:backgroundImage="'/images/screens/wallet/desktop/header_image.jpg'"
			:mobileBackgroundImage="'/images/screens/wallet/mobile/header_image.jpg'"
			:overlayOpacity="0"
			:title="$t('walletScreen.welcomeComponent.title')"
			:description="$t('walletScreen.welcomeComponent.description')"
			:subDescription="$t('walletScreen.welcomeComponent.subDescription')"
			:showStores="true"
			:phoneImage="'/images/elements/home/web/home_phone.png'"
			:phoneAlt="$t('walletScreen.heroJumbotron.phoneAlt')"
		/>
		<step-by-step-section
			:title="$t('walletScreen.stepByStepSection.title')"
			:imageSide="'left'"
			:imageSrc="'/images/screens/wallet/desktop/step1-mobile.png'"
			:imageAlt="$t('walletScreen.stepByStepSection.imageAlt')"
			:items="[
				{
					title: $t('walletScreen.stepByStepSection.itemsOneTitle'),
					text: $t('walletScreen.stepByStepSection.itemsOneDescription'),
				},
				{
					title: $t('walletScreen.stepByStepSection.itemsTwoTitle'),
					text: $t('walletScreen.stepByStepSection.itemsTwoDescription'),
				},
				{
					title: $t('walletScreen.stepByStepSection.itemsThreeTitle'),
					text: $t('walletScreen.stepByStepSection.itemsThreeDescription'),
				},
			]"
		/>

		<step-by-step-section
			:imageSide="'right'"
			:imageSrc="'/images/screens/wallet/desktop/step2-mobile.png'"
			:imageAlt="$t('walletScreen.stepByStepSection.imageAlt')"
			:items="[
				{
					title: $t('walletScreen.stepByStepSection.itemsFourTitle'),
					text: $t('walletScreen.stepByStepSection.itemsFourDescription'),
				},
				{
					title: $t('walletScreen.stepByStepSection.itemsFiveTitle'),
					text: $t('walletScreen.stepByStepSection.itemsFiveDescription'),
				},
				{
					title: $t('walletScreen.stepByStepSection.itemsSixTitle'),
					text: $t('walletScreen.stepByStepSection.itemsSixDescription'),
				},
			]"
			:backgroundImage="'/images/elements/home/web/home_background.png'"
			:backgroundImageMobile="'/images/screens/wallet/mobile/section-bg-mobile.png'"
		/>

		<step-by-step-section
			:imageSide="'left'"
			:imageSrc="'/images/screens/wallet/desktop/step3-mobile.png'"
			:imageAlt="$t('walletScreen.stepByStepSection.imageAlt')"
			:items="[
				{
					title: $t('walletScreen.stepByStepSection.itemsSevenTitle'),
					text: $t('walletScreen.stepByStepSection.itemsSevenDescription'),
				},
				{
					title: $t('walletScreen.stepByStepSection.itemsEightTitle'),
					text: $t('walletScreen.stepByStepSection.itemsEightDescription'),
				},
				{
					title: $t('walletScreen.stepByStepSection.itemsNineTitle'),
					text: $t('walletScreen.stepByStepSection.itemsNineDescription'),
					gradientStart: '#D4F8ED99',
					gradientEnd: '#01DBA8',
				},
			]"
		/>

		<key-features
			:title="$t('walletScreen.keyFeatures.title')"
			:backgroundImage="'/images/screens/wallet/desktop/key-features-bg.jpg'"
			:mobileBackgroundImage="'/images/screens/wallet/mobile/key-features-bg-mobile.jpg'"
			:features="[
				{
					icon: '/images/icons/asset-order-green.svg',
					title: $t('walletScreen.keyFeatures.item1'),
				},
				{
					icon: '/images/icons/license-green.svg',
					title: $t('walletScreen.keyFeatures.item2'),
				},
				{
					icon: '/images/icons/ethereum.svg',
					title: $t('walletScreen.keyFeatures.item3'),
				},
				{
					icon: '/images/icons/transfers-green.svg',
					title: $t('walletScreen.keyFeatures.item4'),
				},
				{
					icon: '/images/icons/shop-green.svg',
					title: $t('walletScreen.keyFeatures.item5'),
				},
				{
					icon: '/images/icons/security-green.svg',
					title: $t('walletScreen.keyFeatures.item6'),
				},
				{
					icon: '/images/icons/circle-check-green.svg',
					title: $t('walletScreen.keyFeatures.item7'),
				},
				{
					icon: '/images/icons/wallet-green.svg',
					title: $t('walletScreen.keyFeatures.item8'),
				},
			]"
		/>

		<wallet-mobile-suggester-component />
	</div>
</template>

<script>
import WalletMobileSuggesterComponent from '@/components/modules/wallet/WalletMobileSuggesterComponent';
import HeroJumbotron from '../components/modules/wallet/HeroJumbotron.vue';
import StepByStepSection from '../components/modules/wallet/StepByStepSection.vue';
import KeyFeatures from '../components/modules/wallet/KeyFeatures.vue';

export default {
	name: 'WalletScreen',
	props: {},
	components: {
		WalletMobileSuggesterComponent,
		HeroJumbotron,
		StepByStepSection,
		KeyFeatures,
	},
	data: () => ({}),
	created() {},
	computed: {},
	methods: {},
};
</script>

<style lang="scss" scoped>
.jumbotron {
	&::v-deep {
		.illustration {
			margin-left: 0 !important;
			position: absolute;
			bottom: -140px;

			@media (max-width: $breakpoint-md) {
				bottom: -100px;
			}

			@media (max-width: $breakpoint-sm) {
				background-position: top !important;

				.bottom-section {
					margin-bottom: $margin-m;
				}
			}
		}
		.illustration-above-store-img {
			max-height: 370px;
			margin-top: 90px;
			margin-bottom: $margin-m;
			img {
				max-height: 370px;
			}
		}
	}
}
</style>
